import { getStore } from './store';
import HeaderCharmType from './schema/HeaderCharmType';

export default function getActiveCharm(): HeaderCharmType {
    return getStore().activeCharm;
}
